"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultItemDescriptionConfig = exports.defaultItemTitleConfig = exports.defaultContainerConfig = void 0;
var defaultContainerConfig = {
    className: 'no-user-select',
    defaultCss: { cursor: 'pointer', borderBottom: '1px solid black' },
    padding: { desktop: '15px', tablet: '15px 0', mobile: '15px 0' }
};
exports.defaultContainerConfig = defaultContainerConfig;
var defaultItemTitleConfig = {
    size: 5,
    defaultCss: { textAlign: 'left' },
    fontSize: {
        desktop: '18px',
        tablet: '16px',
        mobile: '14px'
    },
    margin: {
        desktop: '0',
        tablet: '0',
        mobile: '0'
    }
};
exports.defaultItemTitleConfig = defaultItemTitleConfig;
var defaultItemDescriptionConfig = {
    fontSize: {
        desktop: '18px',
        tablet: '16px',
        mobile: '14px'
    },
    margin: {
        desktop: '0',
        tablet: '0',
        mobile: '0'
    }
};
exports.defaultItemDescriptionConfig = defaultItemDescriptionConfig;
//# sourceMappingURL=Collapsible.js.map